// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__16bBK","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1yE6U"};